(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectTypeMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1740,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
